import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import { PreviewWithFileType, RawDraftContentState } from "~/domains";

import { ApiMembersDirectMessageRoomsDirectMessagesMutateType } from "~/domains/DirectMessage";

type RequestDataType = {
  directMessageRoomId: string;
  body: {
    content: RawDraftContentState;
    attachFiles: PreviewWithFileType[];
  };
};

const request = ({ directMessageRoomId, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ directMessage: body });
  return new ApiClient()
    .post<ApiMembersDirectMessageRoomsDirectMessagesMutateType>(
      `/api/members/direct_message_rooms/${directMessageRoomId}/direct_messages`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersDirectMessageRoomsDirectMessagesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersDirectMessageRoomsDirectMessagesMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
